import { ReactChild } from "react";
import cls from "classnames";
import styles from "./index.module.scss";

const Mask = ({
  children,
  className,
}: {
  children?: ReactChild;
  className: string;
}) => {
  return <div className={cls(styles.mask, className)}>{children}</div>;
};

export default Mask;
